<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      物流账单
    </div>

    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="账单周期" prop="name">
        <el-date-picker v-model="month" type="month" placeholder="选择年月">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="审核状态" prop="name">
        <el-select v-model="checkState" placeholder="全部">
          <el-option label="待审核" value="0"></el-option>
          <el-option label="已审核" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="结算审核" >
        <el-select v-model="payState" placeholder="全部">
          <el-option label="待结算" value="0"></el-option>
          <el-option label="已结算" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchozhi">重置</el-button>
      </el-form-item>
    </el-form>

    <btns @exec="exec"></btns>

    <div class="adc"></div>

    <!-- <div  class="getzahi">

   <div v-for="(iten,i) in adc"  :key="i" @click="gettianjia(i)">
      <div class="getzahi-a" :class="{active : i ===indelst}"  >{{iten.naem}}</div>
   </div>
      <div  class="getzahi-a">入库账单</div>
</div> -->

    <div class="adc"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="账单周期" prop="years"> </el-table-column>

      <el-table-column label="已入库单数" prop="orderCount"> </el-table-column>

      <el-table-column label="已入库总数" prop="allCount"> </el-table-column>

      <el-table-column label="物流总成本" prop="cost"> </el-table-column>

      <el-table-column label="审核状态" prop="checkState">
        
          <template slot-scope="scope">
    
    
           <div v-if="scope.row.checkState==0">待审核</div>

              <div v-if="scope.row.checkState==1">已审核</div>

        </template>
        
          
        
        
         </el-table-column>

      <el-table-column label="结算状态" prop="payState">
        
           <template slot-scope="scope">
    
    
           <div v-if="scope.row.payState==0">待结算</div>

              <div v-if="scope.row.payState==1">已结算</div>

        </template>
        
        
        
       </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link style="margin: 0 10px"  v-if="scope.row.checkState==0" type="primary" @click="getshenhe(scope.row.billId)">审核</el-link>
          <el-link style="margin: 0 10px" type="primary" @click="getckxq(scope.row.billId,scope.row.payState,scope.row.cost,scope.row.checkState,2)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="新增业务员"
      :visible.sync="addORUpdateVisible"
      width="500px"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="姓名">
          <el-input
            v-model="form.name"
            placeholder="请输入业务员姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="性别">
          <el-select v-model="form.region" placeholder="性别">
            <el-option label="男" value="shanghai"></el-option>
            <el-option label="女" value="beijing"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="身份证">
          <el-input
            v-model="form.name"
            placeholder="请输入业务员身份证"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input
            v-model="form.name"
            placeholder="请输入业务员手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系地址">
          <el-input
            v-model="form.name"
            placeholder="请输入业务员联系地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="入职时间">
          <el-time-picker
            v-model="value1"
            :picker-options="{
              selectableRange: '18:30:00 - 20:30:00',
            }"
            placeholder="任意时间点"
          >
          </el-time-picker>
        </el-form-item>

        <el-form-item label="职位">
          <el-select v-model="form.region" placeholder="性别">
            <el-option label="男" value="shanghai"></el-option>
            <el-option label="女" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addORUpdateVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import btns from "@/components/btns.vue";
import ExportExcel from '../../utils/ExportExcel.js';
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    btns,
    ExportExcel,
    breadcrumbs,
  },

  data() {
    return {


      month: "",
      checkState:"",
      payState:"",
      indelst: 0,
      adc: [{ naem: "出库账单" }, { naem: "入库账单" }],

      value1: "",
      form: {
        name: "",
        region: "",
      },

      addORUpdateVisible: false,
      tableData: [{ planCount: "你好" }],
      searchForm: {
        name: "",
      },
    };
  },

  created() {
    this.getInOrderCostList();
  },

  methods: {

       daochu(){
       
         this.$api.activitymsg
        .getInOrderCostExcel(
         
         {
         checkState:this.checkState,
         month:this.month,
         payState:this.payState,
         },
       
        )
        .then((res) => {

        let fileName="入库单.xlsx"
         ExportExcel(res,fileName)
        });
    



      },




  getshenhe(id){

 
      this.$confirm('此期账单无误，确认审核, 是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.activitymsg.checkCost({
         billId:id
        }).then((d) => {
          if (d.code == 200) {
             this.getInOrderCostList();
              this.$message({
          message: '审核成功',
          type: 'warning'
        });
  
          } else {
            this.$message.error(d.msg);
          }
        })
        // console.log(this.tableSelection[0].enable);

      })




  },

 


    getchozhi() {
      (this.checkState = ""),
        (this.month = ""),
        (this.payState = ""),
        this.getInOrderCostList();
    },

    getchaxu() {
      this.getInOrderCostList();
    },

    getInOrderCostList() {
      this.$api.activitymsg
        .getInOrderCostList({
          checkState: this.checkState,
          month: this.month,
          payState: this.payState,
        })
        .then((e) => {
          this.tableData = e.data;
          // this.totalCount = e.totalCount;
        });
    },

    gettianjia(i) {
      this.indelst = i;
    },

    getckxq(id,st,cost,checkState,ob) {

        console.log(id,st,cost,checkState,ob);
      // this.$router.push("/managementhrough/manxiangq");

           this.$router.push({
          path: "/managementhrough/manxiangq",
          query: {
            id: id,
            st:st,
            cost:cost,
            checkState:checkState,
            ob:ob
          }
        })

  


    },

    getadd() {
      this.addORUpdateVisible = true;
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style scoped>
.active {
  background: var(--accent);
  color: #ffffff;
}

.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.adc {
  height: 20px;
}

.getzahi {
  display: flex;
}

.getzahi-a {
  width: 120px;
  height: 50px;
  display: flex;
  border: solid 1px var(--input-border);
  justify-content: center;
  align-items: center;
}
</style>